export const projectDetail = {
    constructionSchedule: '施工进度',
    budgetList: '预算清单',
    projectInfo: '项目信息',
    projectMembers: '项目成员',
    history: '变更历史',
};
